define(['exports', 'react', 'lodash', '../utils/enums', './MCQSection', './ProgrammingSection'], function (exports, _react, _lodash, _enums, _MCQSection, _ProgrammingSection) {
	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _react2 = _interopRequireDefault(_react);

	var _lodash2 = _interopRequireDefault(_lodash);

	var _enums2 = _interopRequireDefault(_enums);

	var _MCQSection2 = _interopRequireDefault(_MCQSection);

	var _ProgrammingSection2 = _interopRequireDefault(_ProgrammingSection);

	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : {
			default: obj
		};
	}

	function _classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}

	var _createClass = function () {
		function defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		return function (Constructor, protoProps, staticProps) {
			if (protoProps) defineProperties(Constructor.prototype, protoProps);
			if (staticProps) defineProperties(Constructor, staticProps);
			return Constructor;
		};
	}();

	function _possibleConstructorReturn(self, call) {
		if (!self) {
			throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		}

		return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}

	function _inherits(subClass, superClass) {
		if (typeof superClass !== "function" && superClass !== null) {
			throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
		}

		subClass.prototype = Object.create(superClass && superClass.prototype, {
			constructor: {
				value: subClass,
				enumerable: false,
				writable: true,
				configurable: true
			}
		});
		if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}

	var Sections = function (_Component) {
		_inherits(Sections, _Component);

		function Sections() {
			_classCallCheck(this, Sections);

			return _possibleConstructorReturn(this, (Sections.__proto__ || Object.getPrototypeOf(Sections)).apply(this, arguments));
		}

		_createClass(Sections, [{
			key: 'renderSections',
			value: function renderSections() {
				var sectionsObj = this.props.sections;

				var mainIndex = 0;

				return _lodash2.default.map(sectionsObj, function (sections, key) {
					if (key && key.toLowerCase() === _enums2.default.reports_sections.QUIZ) {
						return _react2.default.createElement(
							'div',
							null,
							sections.map(function (section) {
								mainIndex++;
								return _react2.default.createElement(_MCQSection2.default, { index: mainIndex, sectionType: key, section: section });
							})
						);
					} else {
						return _react2.default.createElement(
							'div',
							null,
							sections.map(function (section) {
								mainIndex++;
								return _react2.default.createElement(_ProgrammingSection2.default, { index: mainIndex, sectionType: key, section: section });
							})
						);
					}
				});
			}
		}, {
			key: 'render',
			value: function render() {

				return _react2.default.createElement(
					'div',
					null,
					this.renderSections()
				);
			}
		}]);

		return Sections;
	}(_react.Component);

	exports.default = Sections;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/lib/candidate-reports/Sections.js
// module id = 1193
// module chunks = 0